(() => {
  const initialize = () => {
    document.querySelectorAll('dialog.vp-picture-nav').forEach((dialog) => {
      if (dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      const panels = [...dialog.querySelectorAll('[data-vp-panel]')];
      const desktop = window.matchMedia('(min-width: 1000px)');
      let activeKey = 'root';
      let opener;
      const showPanel = (key, focus = false) => {
        const selected = panels.find((panel) => panel.dataset.vpPanel === key);
        if (!selected) return;
        activeKey = key;
        const parent = selected.dataset.vpParent;
        const mainKey = parent && parent !== 'root' ? parent : key;
        dialog.classList.toggle('vp-nav-expanded', desktop.matches && mainKey !== key);
        panels.forEach((panel) => {
          const visible = panel === selected || (desktop.matches && panel.dataset.vpPanel === mainKey);
          panel.hidden = !visible;
          if (!visible) panel.querySelectorAll('.vp-community__video[open]').forEach(details => { details.open = false; });
          panel.classList.toggle('vp-nav-secondary', desktop.matches && panel === selected && mainKey !== key);
        });
        dialog.querySelectorAll('[data-vp-nav-to][aria-expanded]').forEach((button) => {
          button.setAttribute('aria-expanded', String(button.dataset.vpNavTo === key));
        });
        if (focus) selected.querySelector('.vp-picture-nav__title')?.focus({ preventScroll: true });
      };
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-vp-menu-open]');
        if (!trigger || trigger.getAttribute('aria-controls') !== dialog.id) return;
        event.preventDefault();
        opener = trigger;
        showPanel(trigger.dataset.vpMenuOpen);
        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('vp-picture-nav-open');
      });
      dialog.addEventListener('click', (event) => {
        const target = event.target.closest('[data-vp-nav-to]');
        if (target) showPanel(target.dataset.vpNavTo, true);
        if (event.target.closest('[data-vp-nav-close]')) dialog.close();
        if (event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft') return;
        const selected = panels.find((panel) => panel.dataset.vpPanel === activeKey);
        if (selected?.dataset.vpParent) {
          event.preventDefault();
          showPanel(selected.dataset.vpParent, true);
        }
      });
      dialog.addEventListener('close', () => {
        dialog.querySelectorAll('.vp-community__video[open]').forEach(details => { details.open = false; });
        document.documentElement.classList.remove('vp-picture-nav-open');
        opener?.focus({ preventScroll: true });
      });
      desktop.addEventListener('change', () => showPanel(activeKey));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

